import React, { useState } from 'react';
import AuthLayout from '../components/AuthLayout';
import SignupForm from '../components/SignupForm';
import { useAuth } from '../hooks/useAuth';

// Main signup page component
const SignupPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [fullName, setFullName] = useState('');
  const { register, loginWithGoogle, loading, error } = useAuth();

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      // TODO: Set error through a proper error handling mechanism
      return;
    }
    await register(email, password, fullName);
  };

  // Handle Google sign in
  const handleGoogleSignIn = async (e) => {
    e.preventDefault();
    await loginWithGoogle();
  };

  return (
    <AuthLayout>
      <SignupForm
        email={email}
        setEmail={setEmail}
        password={password}
        setPassword={setPassword}
        confirmPassword={confirmPassword}
        setConfirmPassword={setConfirmPassword}
        fullName={fullName}
        setFullName={setFullName}
        onSubmit={handleSubmit}
        onGoogleSignIn={handleGoogleSignIn}
        loading={loading}
        error={error}
      />
    </AuthLayout>
  );
};

export default SignupPage;
